function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMerkmalBestellartikel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10,
    cy: 10,
    r: 10,
    style: {
      fill: "#e41513",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.56 8.9h-1a5.62 5.62 0 0 0-.81-2l.68-.75a6.71 6.71 0 0 0-1.55-1.55l-.75.68a5.62 5.62 0 0 0-2-.81v-1a6.77 6.77 0 0 0-2.2 0v1a5.62 5.62 0 0 0-2 .81l-.75-.68a6.71 6.71 0 0 0-1.59 1.54l.68.75a5.62 5.62 0 0 0-.81 2h-1a6.77 6.77 0 0 0 0 2.2h1a5.62 5.62 0 0 0 .81 2l-.68.75a6.71 6.71 0 0 0 1.55 1.55l.75-.68a5.62 5.62 0 0 0 2 .81v1a6.77 6.77 0 0 0 2.2 0v-1a5.62 5.62 0 0 0 2-.81l.75.68a6.71 6.71 0 0 0 1.55-1.55l-.68-.75a5.62 5.62 0 0 0 .81-2h1a6.77 6.77 0 0 0 0-2.2ZM10 13.48A3.48 3.48 0 1 1 13.48 10 3.48 3.48 0 0 1 10 13.48Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMerkmalBestellartikel);
export default __webpack_public_path__ + "static/media/icon-merkmal-bestellartikel.31067cfa904cfb6aa0bd4f533564669f.svg";
export { ForwardRef as ReactComponent };